import React from 'react';
import moment from 'moment';
import styles from "../JobShiftPreStartView.module.css";

export default function PreStartDetails({ sections, preStartData, previewMode = false }) {
  const safeSectionData = sections.document_project_details && sections.document_project_details.data || {};
  const previewPreStartNumber = safeSectionData.swms_number ? `${safeSectionData.swms_number}-PSC` : "";
  const supervisorDetails = preStartData.shift_answers && preStartData.shift_answers.supervisor_submission || {};

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`}>1</span>
        Pre-Start Details
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.PreviewSectionSubHead}>Document Identity</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Pre-Start No.</span>
                <span className={styles.PreviewValue}>{previewMode ? previewPreStartNumber : (preStartData && preStartData.pre_start_id ? preStartData.pre_start_id : "")}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Shift ID</span>
                <span className={styles.PreviewValue}>{previewMode ? (preStartData && preStartData.shift_id ? preStartData.shift_id : "{shift}") : (preStartData && preStartData.shift_id ? preStartData.shift_id : "")}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Pre-Start Date</span>
                <span className={styles.PreviewValue}>{previewMode ? (preStartData && preStartData.pre_start_date ? moment.utc(preStartData.pre_start_date).format('DD/MM/YYYY') : "{date}") : (preStartData && preStartData.pre_start_date ? moment.utc(preStartData.pre_start_date).format('DD/MM/YYYY') : "")}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Status</span>
                <span className={styles.PreviewValue}>{previewMode ? (String(preStartData && preStartData.status || "").toLowerCase() === "approved" ? "Approved" : "Pending") : "Approved"}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className={styles.PreviewSectionSubHead}>Linked SWMS</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Job Id</span>
                <span className={styles.PreviewValue}>{safeSectionData.job_number || ""}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>SWMS No.</span>
                <span className={styles.PreviewValue}>{safeSectionData.swms_number || ""}</span>
              </td>
              <td colSpan={2}>
                <span className={styles.PreviewLabel}>SWMS Name</span>
                <span className={styles.PreviewValue}>{safeSectionData.swms_name || ""}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className={styles.PreviewSectionSubHead}>Site Details</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Site Name</span>
                <span className={styles.PreviewValue}>{safeSectionData.site_name || ""}</span>
              </td>
              <td colSpan={3}>
                <span className={styles.PreviewLabel}>Site Address</span>
                <span className={styles.PreviewValue}>{safeSectionData.site_address || ""}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className={styles.PreviewSectionSubHead}>Supervisor Details</div>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td>
                <span className={styles.PreviewLabel}>Name</span>
                <span className={styles.PreviewValue}>{supervisorDetails.staff_name || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Position</span>
                <span className={styles.PreviewValue}>{supervisorDetails.job_title || <span>&mdash;</span>}</span>
              </td>
              <td>
                <span className={styles.PreviewLabel}>Phone</span>
                <span className={styles.PreviewValue}>{supervisorDetails.phone_number || <span>&mdash;</span>}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}